import React from "react";
import ProposalForm from "./ProposalForm";
import { useCreateProposalMutation } from "../../redux/api/proposalsApi";
import { useUploadMaterialImageMutation } from "../../redux/api/materialsApi";
import { useNavigate } from "react-router-dom";
import axios from "../../services/axiosInstance";
import { toast } from "react-toastify";

const AddProposalPage = () => {
  const navigate = useNavigate();
  const [createProposal, { isLoading: loading }] = useCreateProposalMutation();
  const [uploadMaterialImage] = useUploadMaterialImageMutation();

  // Helper to upload a material image
  const handleUploadMaterialImage = async (materialId, file) => {
    const formData = new FormData();
    formData.append("image", file);
    formData.append("material_id", materialId);
    formData.append("title", file.name);
    formData.append("description", "");

    try {
      await uploadMaterialImage({ materialId, formData }).unwrap();
    } catch (err) {
      console.error('Error uploading material image:', err);
    }
  };

  const handleAddProposal = async (data, pendingMaterialImages = {}) => {
    try {
      // Create the proposal using RTK Query
      await createProposal(data).unwrap();

      // After proposal is created, upload pending material images
      if (Object.keys(pendingMaterialImages).length > 0) {
        console.log('Uploading pending material images:', pendingMaterialImages);
        
        // For each item that has pending material images
        for (const [itemIndex, pieceImages] of Object.entries(pendingMaterialImages)) {
          const item = data.items[itemIndex];
          if (!item || !item.pieces) continue;

          // For each piece with a pending image
          for (const [pieceId, imageFile] of Object.entries(pieceImages)) {
            // Find the corresponding piece in the result
            const piece = item.pieces.find(p => String(p.id) === String(pieceId));
            if (!piece || !piece.material_name) continue;

            // Find the material that was created for this piece
            // We need to match by material name since the material_id was null
            try {
              // First, get all materials to find the one with matching name
              const materialsResponse = await axios.get('/materials');
              const materials = materialsResponse.data;
              const matchingMaterial = materials.find(m => 
                m.name === piece.material_name && 
                m.code === piece.material_code
              );

              if (matchingMaterial) {
                console.log(`Uploading image for material ${matchingMaterial.id}:`, imageFile);
                await handleUploadMaterialImage(matchingMaterial.id, imageFile);
              } else {
                console.warn(`Could not find material for piece ${pieceId} with name ${piece.material_name}`);
              }
            } catch (error) {
              console.error(`Error uploading image for piece ${pieceId}:`, error);
            }
          }
        }
      }

      toast.success("Proposal created successfully!");
      navigate("/proposals");
    } catch (error) {
      console.error("Error creating proposal:", error);
      toast.error(error?.data?.error || "Failed to create proposal");
    }
  };

  return (
    <div>
      <h1 className="mb-4">Add Proposal</h1>
      {loading && <p>Loading...</p>}
      <ProposalForm onSubmit={handleAddProposal} loading={loading} />
    </div>
  );
};

export default AddProposalPage;
